import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { Fornecedor } from '../models/fornecedor';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class FornecedorService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarFornecedores() {
    return this.http.get<Fornecedor[]>(globals.apiUrl + '/api/Fornecedor/Lista');
  }

  consultarFornecedoresComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Fornecedor/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdFornecedor(idFornecedor) {
    return this.http.get<any>(globals.apiUrl + '/api/Fornecedor/Buscar',
      { params: new HttpParams().set('id', idFornecedor) });
  }

  salvar(fornecedor: Fornecedor) {
    return this.http.post(globals.apiUrl + '/api/Fornecedor/Salvar', fornecedor);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Fornecedor/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
